import NavBar from "../common/NavBar";
import NavBarFooter from "../common/NavBarFooter";

const Affiliate = () => {
    return (
        <div className="outline">
            <NavBar />
            <h1>Affiliates</h1>
            <p>Welcome affiliates, want to promote your book or album? We can add custom questions to the quiz and bring awarness to your art.</p>
            <NavBarFooter />
        </div>
    )
}

export default Affiliate;